import { createFileRoute } from '@tanstack/react-router';
import { AdminModerationReportView } from '@/components/admin/AdminModerationReportView';
import { AdminShell } from '@/components/admin/AdminShell';
import { PLATFORM_ADMIN_ITEMS } from '@/components/admin/admin-sidebar-items';

export const Route = createFileRoute('/_authed/admin/moderation/$reportId')({
  component: ModerationReportPage,
});

function ModerationReportPage() {
  const { reportId } = Route.useParams();
  return (
    <AdminShell items={PLATFORM_ADMIN_ITEMS} active="moderation">
      <AdminModerationReportView reportId={reportId} />
    </AdminShell>
  );
}
